"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { AccountSessionMixins } from "@/service/account-session";
import API from "@ym-framework/api-utils";
import { Component, PropSync, Mixins } from "vue-property-decorator";
let ColumnOperate = class extends Mixins(AccountSessionMixins) {
  toRemote() {
    this.$emit("openRemote", this._column);
  }
  toLauncher() {
    this.$emit("openLauncher", this._column);
  }
  toRecycle() {
    this.$router.push({
      name: "payment",
      query: {
        style: "recycle"
      },
      params: {
        item: JSON.stringify(this._column)
      }
    });
  }
  toRenew() {
    return __async(this, null, function* () {
      try {
        let arr = [];
        arr.push(this._column.oldId);
        yield API.post(`api://base.auth/api/v7/payment/virtualdesktop-verification/renew`, {
          ids: arr
        });
        this.$router.push({
          name: "payment",
          query: {
            style: "renew"
          },
          params: {
            item: JSON.stringify(this._column)
          }
        });
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  toUrge() {
    return __async(this, null, function* () {
      this.$emit("urge", this._column);
    });
  }
  handleCommand(command) {
    return __async(this, null, function* () {
      switch (command.method) {
        case "vd-setting":
          this.$router.push({
            name: "VdSettingView",
            query: {
              vd_id: this._column.id
            }
          });
          break;
        case "add-shop":
          this.$emit("createshop", this._column);
          break;
        case "proxy-setting":
          this.$emit("proxySetting", this._column);
          break;
        case "choose-admin":
          this.$emit("chooseAdmin", this._column);
          break;
        case "delete-vd":
          this.$emit("deleteVD", this._column);
          break;
        case "move-vd":
          this.$emit("moveVD", this._column);
          break;
        case "clear-cache":
          this.$emit("clearCache", this._column);
          break;
        case "proxy-share":
          this.$emit("proxyShare", this._column);
          break;
        case "charge-traffic":
          this.$emit("chargeTraffic", this._column);
          break;
        case "traffic-detail":
          this.$emit("trafficDetail", this._column);
          break;
      }
    });
  }
  handleVDCommand(command) {
    return __async(this, null, function* () {
      switch (command.method) {
        case "vd-setting":
          this.$router.push({
            name: "VdSettingView",
            query: {
              vd_id: this._column.id
            }
          });
          break;
        case "bind-ip":
          this.$emit("bindIP", this._column);
          break;
        case "change-name":
          this.$emit("changename", this._column);
          break;
        case "update-ip":
          this.$router.push({
            name: "payment",
            query: {
              style: "update"
            },
            params: {
              item: JSON.stringify(this._column)
            }
          });
          break;
        case "favorite-on":
          this.$emit("setFavorite", this._column);
          break;
        case "favorite-off":
          this.$emit("setUnFavorite", this._column);
          break;
        case "stick-to-top":
          this.$emit("stickToTop", this._column);
          break;
        case "unstick-to-top":
          this.$emit("unstickToTop", this._column);
          break;
        case "edit-group":
          this.$emit("editGroup", this._column);
          break;
        case "edit-shop":
          this.$emit("editShop", this._column);
          break;
        case "move-shop":
          this.$emit("moveShop", this._column);
          break;
      }
    });
  }
  toDeleteVd() {
    this.$emit("realDeleteVD", this._column);
  }
  createShop() {
    this.$emit("createshop", this._column);
  }
};
__decorateClass([
  PropSync("column")
], ColumnOperate.prototype, "_column", 2);
ColumnOperate = __decorateClass([
  Component({})
], ColumnOperate);
export {
  ColumnOperate as default
};
